const styles = {
  image: {
    objectFit: 'cover',
    height: 200,
    width: '100%',
    borderRadius: '10px',
  },
  bar: {
    borderRadius: '10px 10px 0px 0px',
    background:
      'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
      'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
  checkbox: {
    color: 'white',
    '&.Mui-checked': {
      color: 'white',
    },
  },
  btn: {
    mb: 2,
  },
  loader: {
    zIndex: (theme) => theme.zIndex.modal + 1,
    color: 'primary.white',
    backdropFilter: 'blur(2px)',
    transition: 'opacity 0.3s ease-in-out',
  },
};

export default styles;
